import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import { Flex } from 'antd';

import { getPromocodeFields, renderField } from '../utils/fields';
import {
    PROMOCODE_FIELD_NAMES,
    PROMOCODE_FORM_TYPE,
    PromocodeDTO,
} from '../service/promocodes.interface';
import { useAppSelector } from '../../../../../store';
import { selectPromocode } from '../store/promocode.slice';

export const PromocodeForm = ({
    formik,
}: {
    formik: ReturnType<typeof useFormik<PromocodeDTO>>;
}) => {
    const { formType } = useAppSelector(selectPromocode);

    useEffect(() => {
        if (formType === PROMOCODE_FORM_TYPE.UNIQUE) {
            formik.setFieldValue(PROMOCODE_FIELD_NAMES.QUANTITY, 1);
        }
    }, [formType]);

    const fields = getPromocodeFields(formType)
        .slice()
        .sort((a, b) => (a.position ?? 0) - (b.position ?? 0));

    return (
        <form>
            <Flex vertical style={{ width: 326 }} gap={24}>
                {fields.map(field =>
                    field.hidden?.(formik.values) ? null : (
                        <React.Fragment key={field.name}>
                            {renderField(field, formik)}
                        </React.Fragment>
                    )
                )}
            </Flex>
        </form>
    );
};
